module.exports = __webpack_public_path__ + "media/images/icon-help@3x-e8dca5edd30c039fda57eab3ffb335ff.png";